/**
 * 视频特效样式数据配置
 * 基于 ai-video-effect-style.json 生成
 */

// 图片类型枚举
export const IMG_TYPE = {
    SINGLE: 'SINGLE',
    DOUBLE: 'DOUBLE',
    VIDEO_AND_PIC: 'VIDEO_AND_PIC',
};

// 特效类型枚举
export const EFFECT_TYPE = {
    WAN_EFFECTS: 'WAN_EFFECTS',
    KLING16_EFFECT_STD: 'KLING16_EFFECT_STD',
    KLING16: 'KLING16',
    IMG2IMG_KLING16_PROMPT: 'IMG2IMG_KLING16_PROMPT',
};

// 视频特效样式列表
export const VIDEO_EFFECT_STYLE_LIST = [
    {
        name: 'character-swap',
        category: 'character-swap',
        key: 'character-swap',
        description: 'upload-an-image-and-a-reference-video',
        creditPrice: 15,
        list: [
            {
                imgType: IMG_TYPE.VIDEO_AND_PIC,
                type: EFFECT_TYPE.WAN_EFFECTS,
                preset_prompt: null,
                needs_prompt: false,
            },
        ],
    },
    {
        name: 'squish',
        category: 'squish',
        key: 'squish',
        description: 'upload-an-image-with-a-clear-subject.',
        creditPrice: 40,
        list: [
            {
                imgType: IMG_TYPE.SINGLE,
                type: EFFECT_TYPE.KLING16_EFFECT_STD,
                preset_prompt: null,
                needs_prompt: false,
            },
        ],
    },
    {
        name: 'dizzy',
        category: 'dizzydizzy',
        key: 'dizzydizzy',
        description: 'upload-an-image-with-a-clear-subject.',
        creditPrice: 40,
        list: [
            {
                imgType: IMG_TYPE.SINGLE,
                type: EFFECT_TYPE.KLING16_EFFECT_STD,
                preset_prompt: null,
                needs_prompt: false,
            },
        ],
    },
    {
        name: 'expansion',
        category: 'expansion',
        key: 'expansion',
        description: 'upload-an-image-with-a-clear-subject.',
        creditPrice: 40,
        list: [
            {
                imgType: IMG_TYPE.SINGLE,
                type: EFFECT_TYPE.KLING16_EFFECT_STD,
                preset_prompt: null,
                needs_prompt: false,
            },
        ],
    },
    {
        name: 'cakeify',
        category: 'cakeify',
        key: 'cakeify',
        description: 'upload-an-image-with-a-clear-subject.',
        creditPrice: 40,
        list: [
            {
                imgType: IMG_TYPE.SINGLE,
                type: EFFECT_TYPE.WAN_EFFECTS,
                preset_prompt: null,
                needs_prompt: false,
            },
        ],
    },
    {
        name: 'product',
        category: 'product',
        key: 'product',
        description: 'upload-an-image-with-a-clear-subject.',
        creditPrice: 40,
        list: [
            {
                imgType: IMG_TYPE.SINGLE,
                type: EFFECT_TYPE.KLING16,
                preset_prompt: '',
                needs_prompt: false,
            },
        ],
    },
    {
        name: 'crush',
        category: 'crush',
        key: 'crush',
        description: 'upload-an-image-with-a-clear-subject.',
        creditPrice: 40,
        list: [
            {
                imgType: IMG_TYPE.SINGLE,
                type: EFFECT_TYPE.WAN_EFFECTS,
                preset_prompt: null,
                needs_prompt: false,
            },
        ],
    },
    {
        name: 'fuzzy',
        category: 'fuzzyfuzzy',
        key: 'fuzzyfuzzy',
        description: 'upload-an-image-with-a-clear-subject.',
        list: [
            {
                imgType: IMG_TYPE.SINGLE,
                type: EFFECT_TYPE.KLING16_EFFECT_STD,
                preset_prompt: null,
                needs_prompt: false,
            },
        ],
    },
    {
        name: 'kiss',
        category: 'kiss',
        key: 'kiss',
        description: 'upload-a-couple-photo-or-two-solo-photos,-better-shows-half-body/full-body.',
        creditPrice: 40,
        list: [
            {
                imgType: IMG_TYPE.DOUBLE,
                type: EFFECT_TYPE.KLING16_EFFECT_STD,
                preset_prompt: null,
                needs_prompt: false,
            },
            {
                imgType: IMG_TYPE.SINGLE,
                type: EFFECT_TYPE.KLING16,
                preset_prompt: '',
                needs_prompt: false,
            },
        ],
    },
    {
        name: 'hug',
        category: 'hug',
        key: 'hug',
        description: 'upload-a-couple-photo-or-two-solo-photos,-better-shows-half-body/full-body.',
        list: [
            {
                imgType: IMG_TYPE.DOUBLE,
                type: EFFECT_TYPE.KLING16_EFFECT_STD,
                preset_prompt: null,
                needs_prompt: false,
            },
            {
                imgType: IMG_TYPE.SINGLE,
                type: EFFECT_TYPE.KLING16,
                preset_prompt: '',
                needs_prompt: false,
            },
        ],
    },
    {
        name: 'muscle',
        category: 'muscle',
        key: 'muscle',
        description: 'upload-a-solo-photo,-ideally-half-body/full-body.',
        default_prompt: 'default',
        creditPrice: 40,
        list: [
            {
                imgType: IMG_TYPE.SINGLE,
                type: EFFECT_TYPE.WAN_EFFECTS,
                preset_prompt: null,
                needs_prompt: false,
                upload_text: '1-solo-photo',
            },
        ],
    },
    {
        name: 'baby',
        category: 'baby',
        key: 'baby',
        description: 'upload-a-solo-photo,-ideally-half-body/full-body.',
        creditPrice: 40,
        list: [
            {
                imgType: IMG_TYPE.SINGLE,
                type: EFFECT_TYPE.WAN_EFFECTS,
                preset_prompt: null,
                needs_prompt: false,
                upload_text: '1-solo-photo',
            },
        ],
    },
    {
        name: 'bloom',
        category: 'bloombloom',
        key: 'bloombloom',
        description: 'upload-an-image-of-a-building.',
        creditPrice: 40,
        list: [
            {
                imgType: IMG_TYPE.SINGLE,
                type: EFFECT_TYPE.KLING16_EFFECT_STD,
                preset_prompt: null,
                needs_prompt: false,
            },
        ],
    },
    {
        name: 'bride',
        category: 'bride',
        key: 'bride',
        description: 'upload-a-solo-photo,-ideally-half-body/full-body.',
        creditPrice: 40,
        list: [
            {
                imgType: IMG_TYPE.SINGLE,
                type: EFFECT_TYPE.WAN_EFFECTS,
                preset_prompt: null,
                needs_prompt: false,
                upload_text: '1-solo-photo',
            },
        ],
    },
    {
        name: 'deflate',
        category: 'deflate',
        key: 'deflate',
        description: 'upload-an-image-with-a-clear-subject.',
        creditPrice: 40,
        list: [
            {
                imgType: IMG_TYPE.SINGLE,
                type: EFFECT_TYPE.WAN_EFFECTS,
                preset_prompt: null,
                needs_prompt: false,
            },
        ],
    },
    {
        name: 'ghibli',
        category: 'animeify',
        key: 'animeity',
        description: '',
        creditPrice: 40,
        list: [
            {
                imgType: IMG_TYPE.SINGLE,
                type: EFFECT_TYPE.WAN_EFFECTS,
                preset_prompt: null,
                needs_prompt: true,
            },
        ],
    },
    {
        name: 'fight',
        category: 'fighting',
        key: 'fighting',
        description: 'upload-a-couple-photo,-ideally-half-body/full-body.',
        creditPrice: 40,
        list: [
            {
                imgType: IMG_TYPE.SINGLE,
                type: EFFECT_TYPE.KLING16,
                preset_prompt: '',
                needs_prompt: false,
                upload_text: 'upload-a-photo',
            },
        ],
    },
    {
        name: 'puppy',
        category: 'puppy',
        key: 'puppy',
        description: 'upload-a-solo-photo,-ideally-half-body/full-body.',
        creditPrice: 40,
        list: [
            {
                imgType: IMG_TYPE.SINGLE,
                type: EFFECT_TYPE.WAN_EFFECTS,
                preset_prompt: null,
                needs_prompt: false,
                upload_text: '1-solo-photo',
            },
        ],
    },
    {
        name: 'picture book',
        category: 'picture-book-2',
        key: 'picture-book',
        description: '',
        creditPrice: 40,
        list: [
            {
                imgType: IMG_TYPE.SINGLE,
                type: EFFECT_TYPE.IMG2IMG_KLING16_PROMPT,
                preset_prompt: null,
                needs_prompt: true,
            },
        ],
    },
    {
        name: 'gun shooting',
        category: 'gun-shooting',
        key: 'gun-shooting',
        description: 'upload-a-solo-photo,-ideally-half-body/full-body.',
        creditPrice: 40,
        list: [
            {
                imgType: IMG_TYPE.SINGLE,
                type: EFFECT_TYPE.WAN_EFFECTS,
                preset_prompt: null,
                needs_prompt: false,
                upload_text: '1-solo-photo',
            },
        ],
    },
    {
        name: 'action figure',
        category: 'action-figure-1',
        key: 'action-figure',
        description: 'upload-a-solo-photo,-ideally-half-body/full-body.',
        creditPrice: 40,
        list: [
            {
                imgType: IMG_TYPE.SINGLE,
                type: EFFECT_TYPE.IMG2IMG_KLING16_PROMPT,
                preset_prompt: '',
                needs_prompt: false,
                upload_text: '1-solo-photo',
            },
        ],
    },
    {
        name: 'felt',
        category: 'felt',
        key: 'felt',
        description: '',
        creditPrice: 40,
        list: [
            {
                imgType: IMG_TYPE.SINGLE,
                type: EFFECT_TYPE.IMG2IMG_KLING16_PROMPT,
                preset_prompt: null,
                needs_prompt: true,
            },
        ],
    },
    {
        name: 'hair growth',
        category: 'growhair',
        key: 'growhair',
        description: 'upload-a-solo-photo,-ideally-half-body/full-body.',
        creditPrice: 40,
        list: [
            {
                imgType: IMG_TYPE.SINGLE,
                type: EFFECT_TYPE.KLING16,
                preset_prompt: '',
                needs_prompt: false,
                upload_text: '1-solo-photo',
            },
        ],
    },
    {
        name: 'mona lisa',
        category: 'mona-lisa',
        key: 'mona-lisa',
        description: 'upload-a-solo-photo,-ideally-half-body/full-body.',
        creditPrice: 40,
        list: [
            {
                imgType: IMG_TYPE.SINGLE,
                type: EFFECT_TYPE.WAN_EFFECTS,
                preset_prompt: null,
                needs_prompt: false,
                upload_text: '1-solo-photo',
            },
        ],
    },
];

export default {
    VIDEO_EFFECT_STYLE_LIST,
    IMG_TYPE,
    EFFECT_TYPE,
};
